import React from "react";
import PageContent from "../PageContent";
import PanelError from "../PanelError";

function PageDeclined() {
  const text =
    "Unfortunately we cannot process your application at this time. If you feel that this decision has been made in error please contact the online support team or your local branch.";
  return (
    <PageContent>
      <header />
      <h1>Declined</h1>
      <PanelError text={text} />
    </PageContent>
  );
}

export default PageDeclined;
